<script lang="ts">
  import Lead from "$lib/Lead.svelte";
  import theTime from "$lib/utils/the-time";
  import lang from "$lib/langStore";
  import Picture from "$lib/Picture.svelte";
  import { breakpoints as br } from "$lib/utils/getBreakpoints";
  import type { SanityPicture as Image } from "$lib/types/shared";

  interface Props {
    title: string;
    lead: string;
    author: string | null;
    publishedAt: string;
    image: Image | null | undefined;
  }

  let { title, lead, author, publishedAt, image }: Props = $props();
</script>

<header>
  <div class="grid max-w-prose mx-a">
    <h1 class="leading-tight max-w-prose text-h-hero">
      {title}
    </h1>

    <div class="items-end mt-0">
      <Lead class="mt-0 max-w-prose leading-normal landscape:hyphens-manual">{lead}</Lead>
    </div>

    <dl
      class="py-4 px-inline bg-$primary-light-40 py-4 grid grid-cols-[auto_1fr] text-sm children-m-0 gap-x-inline rounded-2xl"
    >
      {#if author}
        <dt>Tekst</dt>
        <dd>{author}</dd>
      {/if}

      <dt>Publisert</dt>
      <dd>
        <time datetime={publishedAt} class="dt-published">
          {theTime(publishedAt).toLocaleDateString($lang || "nb", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
        </time>
      </dd>
      {#if image?.credit}
        <dt>Foto</dt>
        <dd>{image?.credit}</dd>
      {/if}
    </dl>

    {#if !!image}
      <p class="featured-image-container order--1 mb-0 mt-1 laptop:mt-4">
        <Picture
          src={image.src || ""}
          width={image?.asset?.metadata?.dimensions?.width}
          height={image?.asset?.metadata?.dimensions?.height}
          srcset={image.srcset}
          srcsetWebp={image.srcsetWebp}
          sizes={`(min-width: ${br.wide}) 50vw, (min-width: ${br.desktop}) 60vw, (min-width: ${br.laptop}) 70vw, (min-width: ${br.tablet}) 90vw, 100vw`}
          alt={image?.alt || ""}
          class="u-photo w-full laptop:w-[min(100%,var(--w-prose))] object-contain rounded-2xl"
        />
      </p>
    {/if}
  </div>
</header>

<style>
  dt::after {
    content: ":";
  }
</style>
